module.exports = __webpack_public_path__ + "img/symbol_0.0969873c.png";